import PythonApi from "../services/PythonApi";

export default {
    async getAll() {
        const url = "tags";
        return await PythonApi().get(url);
    },

    async getWithCow() {
        const url = "tags", params = new URLSearchParams();
        params.append('with_cow', true);
        return await PythonApi().get(url, params);
    },

    async clear(data) {
        const url = "tags";
        return await PythonApi().delete(url, new URLSearchParams(), data);
    },

    async assign(data) {
        const url = "tags";
        return await PythonApi().put(url, data);
    }
}


// WEBPACK FOOTER //
// ./src/api/tags-api.js